export type SortOption = 'newest' | 'oldest' | 'price-low' | 'price-high' | 'ending-soon' | 'relevance'

export interface ListingFilters {
  // Text search
  query: string

  // Category filters
  category: string
  group: string

  // Location
  location: string

  // Price range
  priceMin: string
  priceMax: string

  // General filters
  condition: string
  saleType: string
  shipping: string

  // Sort
  sortBy: SortOption

  // Vehicle-specific filters
  make: string
  model: string
  yearMin: string
  yearMax: string
  transmission: string
}

export const DEFAULT_FILTERS: ListingFilters = {
  query: '',
  category: '',
  group: '',
  location: '',
  priceMin: '',
  priceMax: '',
  condition: '',
  saleType: '',
  shipping: '',
  sortBy: 'newest',
  make: '',
  model: '',
  yearMin: '',
  yearMax: '',
  transmission: '',
}

// Price range presets
export const PRICE_PRESETS = [
  { label: 'Under $100', min: 0, max: 100 },
  { label: '$100 - $500', min: 100, max: 500 },
  { label: '$500 - $1,000', min: 500, max: 1000 },
  { label: '$1,000 - $5,000', min: 1000, max: 5000 },
  { label: '$5,000+', min: 5000, max: undefined },
]
